import { classes } from '../../../utils/class-utils';

export const baseStyles = classes([
  'transition-opacity',
  'duration-200',
  'flex',
  'items-center',
  'justify-center',
  'p-2',
  'md:p-3',
  'lg:p-4',
  'shrink-0',
]);

export const stateStyles = {
  disabled: classes(['pointer-events-none', 'opacity-50']),
};

export const iconStyles = {
  positionRight: 'rotate-180',
  disabled: 'gray',
  default: 'black',
};
